RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const CompanyCell = widgets.CompanyCell = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#socialPostsCompanyExpansionCellTemplate',
        className: 'company-cell',
        serializeData: function () {
            const me = this;
            const companyId = Number(_.last(me.getOption('data')));
            const company = RivalIQ.state.landscape.get('companies').get(companyId);

            return _.extend(company.toJSON(), {
                isFocus: companyId === RivalIQ.state.utils.getFocusedCompanyId(),
                presence_icon_url: company.getIcon(),
                companyAbbr: RivalIQ.utils.companyDisplay.getAbbreviation(company.attributes)
            });
        }
    });

    const TextInsight = widgets.HashtagTableTextInsight = RivalIQ.views.ItemView.mixin({
        template: '#socialPostsInsightsTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            insight: '.x-insight',
            hashtagLink: '.hashtag-link'
        },

        events: {
            'click @ui.hashtagLink': 'onHashtagClick'
        },

        loadData: function (callback) {
            const me = this;

            const definition = me.getOption('metric');

            // NOTE: this metric will request data for all companies, not just the focus company;
            // we'll filter out the other companies later. If we were to specify companyId here, we'd
            // pass that down to the server for filtering there. It's a better use of the cacheLayer
            // to do the filtering ourselves as it saves an XHR to the server.
            const focusDef = definition.build({
                property: 'count',
                aggregate: undefined,
                dimensions: ['companyId']
            });
            const mostEngagingDef = definition.build({
                property: 'avg_engagement_rate_per_post',
                aggregate: undefined
            });

            $.when(definition.fetch(), focusDef.fetch(), mostEngagingDef.fetch()).done(function (landscape, focus, mostEngaging) {
                me.landscapeHashtags = landscape;
                me.focusHashtags = focus;
                me.mostEngaging = mostEngaging;

                callback();
            });
        },

        onRenderLoaded: function () {
            const me = this;

            me.ui.insight.html(me.getTextInsight());

        },

        getTextInsight: function () {
            const me = this;

            let landscapeHashtags = me.landscapeHashtags.getValue({
                format: false
            });
            const engagementHashtags = me.mostEngaging.getValue({
                format: false
            });
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

            if (!landscapeHashtags.length) {
                // NOTE set a CSS class so we can format the message like a typical no data message
                me.ui.insight.addClass('x-no-data');
                return `No Hashtags found in this set of ${postWord}s.`;
            } else {
                me.ui.insight.removeClass('x-no-data');
            }

            // construct something more friendly to multiple sorts
            const hashtags = _.map(landscapeHashtags, function (hashtag) {
                const hashtagName = hashtag[0];
                const count = hashtag[1];
                const avgEngagementRate = _.last(_.find(engagementHashtags, function (focusHashtag) {
                    return focusHashtag[0].toLowerCase() === hashtagName.toLowerCase();
                }));
                return [hashtagName, count, avgEngagementRate];
            });

            // the table's secondary sort should be applied here as well
            landscapeHashtags = _.orderBy(hashtags, [1, 2], ['desc', 'desc']);

            // Cached hashtags results can be larger than the number displayed
            // in the table. Trim insight to table size
            const limit = me.getOption('limit');
            landscapeHashtags = _.take(landscapeHashtags, limit);

            // we should (try to) get the most engaging hashtag within the set we display.
            // note that this isn't perfect; many hashtags with the same avg engagement rates
            // may mean that the set we're providing insight for isn't exactly the set the table displays.
            const mostEngaging = _.reduce(landscapeHashtags, function (best, hashtag) {
                if (!best || hashtag[2] > best[2]) {
                    return hashtag;
                }
                return best;
            });
            let mostEngagingHashtag = mostEngaging[0];
            const focusCompanyId = RivalIQ.state.utils.getFocusedCompanyId();
            const focusHashtags = _(me.focusHashtags.getValue({
                format: false
            }))
                .filter(function (data) {
                    const companyId = Number(data[1]);
                    return companyId === focusCompanyId;
                })
                .filter(function (data) {
                    return !_.isUndefined(_.last(data)) && _.find(landscapeHashtags, function (datum) {
                        return datum[0].toLowerCase() === data[0].toLowerCase();
                    });
                })
                .value();

            const isFiltered = App.utils.arePostsFiltered(me.getOption('dashboardModel'));

            const usedTop = _.find(focusHashtags, function (data) {
                return _.head(data).toLowerCase() === mostEngagingHashtag.toLowerCase();
            });

            if (landscapeHashtags.length === 1) {
                if (usedTop) {
                    return `You are using the only Hashtag in this set of ${postWord}s.`;
                }

                return `You have not used the only Hashtag in this set of ${postWord}s.`;
            }

            if (_.last(mostEngaging) === 0) {
                if (isFiltered) {
                    return `Among ${postWord}s matching your query, Hashtags didn't generate any engagement during this time period.`;
                } else {
                    return `Hashtags didn't generate any engagement during this time period.`;
                }
            }

            const hashtag = mostEngagingHashtag;
            mostEngagingHashtag = `#${mostEngagingHashtag}`;

            const mostEngagingLink =
                $.tagHtml('span', {
                    'data-hashtag': hashtag,
                    class: 'hashtag-link',
                    text: mostEngagingHashtag
                });

            const strong = function (txt) {
                return $.tagHtml('strong', {
                    text: txt
                });
            };

            const insight = [];

            if (isFiltered) {
                insight.push(`Among ${postWord}s matching your query,`);
            } else {
                insight.push('Of the', strong(landscapeHashtags.length), 'most broadly used Hashtags,');
            }

            insight.push(mostEngagingLink, `generated the highest Engagement Rate by ${audienceName}.`);

            if (!focusHashtags.length) {
                insight.push(`You didn't use any of these Hashtags.`);
            } else {
                insight.push('You used', strong(focusHashtags.length), 'of these', strong(landscapeHashtags.length), 'Hashtags,');

                if (usedTop) {
                    insight.push('including ', `${mostEngagingLink}. Good work!`);
                } else {
                    insight.push(`but you didn't use`, `${mostEngagingLink}.`);
                }
            }

            return insight.join(' ');
        },

        onHashtagClick: function (e) {
            const me = this;

            const target = $(e.target);
            const hashtag = target.data('hashtag');

            const props = me.getProps();

            if (!_.isEmpty(props.searchTerm)) {
                props.searchTerm = `(${props.searchTerm}) AND #${hashtag}`;
            } else {
                props.searchTerm = `#${hashtag}`;
            }
            props.forName = `#${hashtag}`;

            const source = RivalIQ.data.channels.get(props.channel).get('channel');
            RivalIQ.apps.SocialPosts.views.PostsModal.show(props, source);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsViewPostsModal, _.extend({
                widgetId: me.dashboardModel.widgetId
            }, props));
        }
    });

    const HashtagsUsageTableView = App.widgets.PostAggregatesTableView.extend({

        emptyView: Marionette.ItemView.extend({
            template: '#socialPostsHashtagNoResultsEmptyTemplate'
        })

    });

    const HashtagsUsageTableWidget = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        view: HashtagsUsageTableView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_HASHTAG_USAGE_TABLE, HashtagsUsageTableWidget);

    const HashtagUsage = RivalIQ.views.LayoutView.mixin({
        template: '#socialPostsHashtagUsageTemplate',
        className: 'hashtag-usage',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        regions: {
            table: '.x-table-region',
            insight: '.x-insight-region'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights,
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        templateHelpers: function () {
            const me = this;
            return {
                url: function () {
                    return me.dashboardModel.getPath({
                        limit: -1,
                        widgetId: 'hashtags'
                    });
                }
            };
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.showTable();
            me.showTextInsight();
        },

        showTextInsight: function () {
            const me = this;

            // The text insight widget should sort by the column it's displaying insights on (companyCount in this case).
            let definition = me.dashboardModel.metrics.at(me.getProp('sortOrder'));
            definition = definition.build({
                orderBy: definition.serialize()
            });

            me.insight.show(new TextInsight({
                dashboardModel: me.dashboardModel,
                searchTerm: me.getProp('searchTerm'),
                limit: me.getProp('limit'),
                metric: definition
            }));
        },

        showTable: function () {
            const me = this;

            me.table.showWidget(me.dashboardModel.getWidget('hashtag-table'), {
                className: `table-double-header ${me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive'}`
            });
        }
    });

    const FooterView = RivalIQ.apps.Dashboard.views.PanelFooter.extend({
        template: '#socialPostsHashtagFooterTemplate',
        className: 'panel-footer'
    });

    function getFilenameTitle() {
        return 'hashtag usage';
    }

    function getBaseMetric() {
        return new RivalIQ.models.MetricDefinition({
            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_HASHTAGS.id,
            dimensions: ['hashtag']
        });
    }

    const DetailPanelView = widgets.PostDimensionDetailsPanel.extend({

        showActions: function () {
            const me = this;

            if (me.dashboardModel.isFocus()) {

                me.actions.show(new RivalIQ.views.ShowSummaryRowSwitch({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                const minCompaniesDefaultValue = me.getProp('hashtagsMinCompanies') || 1;
                const minPostsDefaultValue = me.getProp('hashtagsMinPosts') || 1;

                const MinimumCompaniesDropdown = App.utils.createNumericFilterDropdown({
                    label: 'Min. Companies',
                    prop: 'hashtagsMinCompanies',
                    propDefaultValue: minCompaniesDefaultValue,
                    min: 1,
                    max: 10
                });

                me.actions.show(new MinimumCompaniesDropdown({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                const postWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;

                const MinimumPostsDropdown = App.utils.createNumericFilterDropdown({
                    label: `Min. ${postWord}`,
                    prop: 'hashtagsMinPosts',
                    propDefaultValue: minPostsDefaultValue,
                    min: 1,
                    max: 10
                });

                me.actions.show(new MinimumPostsDropdown({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                me.setProps({
                    hashtagsMinPosts: minPostsDefaultValue,
                    hashtagsMinCompanies: minCompaniesDefaultValue
                });
            }

            widgets.PostDimensionDetailsPanel.prototype.showActions.apply(me, arguments);
        }
    });

    const HashtagUsageWidget = widgets.PostDimension.extend({
        title: 'Hashtags',
        description: RivalIQ.strings.social_posts_hashtags_info,
        footerView: FooterView,
        hasFooter: _.constant(true),
        processProps: function (props) {
            const me = this;

            const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

            _.defaults(props, {
                limit: 8,
                showDescriptions: true,
                metrics: [
                    {
                        property: 'name'
                    },
                    'companies_using',
                    'count',
                    {
                        property: 'avg_engagement_rate_per_post',
                        description: RivalIQ.str('social_posts_engagement_rate_by_follower', postWord, audienceName.toLocaleLowerCase(), audienceName)
                    }
                ],
                // if this is changed, please also update TextInsight accordingly
                orderBy: [1, 2],
                sortOrder: 1
            });

            // No all in the summary view
            props.includeSummaryRow = false;

            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.metrics = me.metricsCollection = RivalIQ.models.MetricDefinition.buildMetric(me.metric, props.metrics);

            return props;
        },
        view: HashtagUsage,
        widgetDefinitions: function () {
            const me = this;

            return [
                {
                    instanceId: 'hashtag-table',
                    widgetId: RivalIQ.enums.widgetTypes.SOCIAL_POSTS_HASHTAG_USAGE_TABLE,
                    metricsCollection: me.metrics,
                    neverFilter: true,
                    props: {
                        sortable: true,
                        metrics: undefined
                    }
                }
            ];
        },
        viewMorePath: function () {
            const me = this;
            // TODO this should not require a specific instanceid
            return me.getPath({
                instanceId: 'hashtags'
            });
        },
        getFilenameTitle: getFilenameTitle,
        getBaseMetric: getBaseMetric
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_HASHTAG_USAGE, HashtagUsageWidget);

    function normalizeMetricColumns(props) {

        const me = this;

        const companiesUsing = _.find(props.metrics, function (metric) {
            return _.get(metric, 'property', metric) === 'companies_using';
        });

        const engRatePerPost = _.find(props.metrics, function (metric) {
            return _.get(metric, 'property', metric) === 'avg_engagement_rate_per_post';
        });

        // in the export case, we'll have name already in the set of metrics. Let's remove them
        // since we're going to add them below.
        me.metrics = _.reject(props.metrics, function (metric) {
            return _.includes(['name', 'companies_using', 'avg_engagement_rate_per_post'], _.get(metric, 'property', metric));
        });

        // Consistent ordering for these metrics
        // NOTE this works for hashtags only because we dont have multiple
        // metrics with these properties
        if (engRatePerPost) {
            me.metrics.unshift(engRatePerPost);
        }

        if (companiesUsing) {
            me.metrics.unshift(companiesUsing);
        }

        // Always include hashtag name as the first column
        me.metrics.unshift({
            property: 'name',
            dimensionView: CompanyCell
        });

        me.metricsCollection = me.metrics;
        RivalIQ.models.MetricDefinition.build(me, me.metric, {
            descriptionDimensions: ['channel', 'hashtag']
        }, 'metricsCollection');

        _.defaults(props, {
            orderBy: me.metrics.length
        });
    }

    const HashtagsTableView = App.widgets.PostAggregatesTableView.extend({

        emptyView: Marionette.ItemView.extend({
            template: '#socialPostsHashtagNoResultsTemplate'
        }),

        getPostsModalProps: function (data, dimensionRow) {
            const me = this;

            const props = App.widgets.PostAggregatesTableView.prototype.getPostsModalProps.apply(me, arguments);

            // add in subordinate row info if present.
            if (dimensionRow) {
                const companyId = Number(_.last(_.head(dimensionRow)));
                props.companyIds = [companyId];
            }

            return props;
        }
    });

    const HashtagsWidget = widgets.PostDimensionTable.extend({
        title: 'Hashtags',
        description: RivalIQ.strings.social_posts_hashtags_info,
        footerView: FooterView,
        propsToSerializeForExport: [
            'metrics',
            'hashtagsMinCompanies',
            'hashtagsMinPosts'
        ].concat(App.utils.widgetExportProps),
        getFilenameTitle: getFilenameTitle,
        getBaseMetric: getBaseMetric,
        normalizeMetricColumns: normalizeMetricColumns,
        expansionTracking: RivalIQ.tracking.metric.SocialPostsExpandedTableRow,
        getView: _.constant(HashtagsTableView),
        detailPanelView: DetailPanelView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_HASHTAG_TABLE, HashtagsWidget);

});
